/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum IamUserStatus {
    Pending = 'PENDING',
    Created = 'CREATED',
    Active = 'ACTIVE',
    Disabled = 'DISABLED',
    Deleted = 'DELETED',
    Suspended = 'SUSPENDED'
}

export function IamUserStatusFromJSON(json: any): IamUserStatus {
    return IamUserStatusFromJSONTyped(json, false);
}

export function IamUserStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): IamUserStatus {
    return json as IamUserStatus;
}

export function IamUserStatusToJSON(value?: IamUserStatus | null): any {
    return value as any;
}

